import type { Rect } from './types';

/**
 * 투영 영역의 가로 비율 c(0~1)를 원본 x 로 되돌린다(마플 `makeX` 대응).
 * θ = acos(1 − 2c) 와 같은 값을 2·asin(√c) 로 계산해 왼쪽 끝에서도 정밀도를 지킨다.
 * c 는 0~1 이어야 한다. 범위 확인은 호출하는 쪽이 한다.
 */
export function makeX(c: number, area: Pick<Rect, 'left' | 'width'>): number {
  return sourceXFromAngle(2 * Math.asin(Math.sqrt(c)), area);
}

/** 원통 각도 θ(0~π)를 원본 x 로 바꾼다. 왼쪽 끝이 0, 오른쪽 끝이 π 다. */
export function sourceXFromAngle(theta: number, area: Pick<Rect, 'left' | 'width'>): number {
  return area.left + (area.width * theta) / Math.PI;
}
